import { ILocation } from "@src/store/app_manager/types";

// Find given location id from location list
export function isLocationIdExists(
  locationId: string,
  locationsList: any[]
): boolean {
  for (const location of locationsList ?? []) {
    if (locationId === location.restaurant_id) {
      return true;
    }
  }
  return false;
}
